import React from 'react';

// The 6-column bento grid every page section is laid out on.
const SectionGrid = ({ children, className = '' }) => (
  <section className={`grid grid-cols-6 gap-3 px-8 max-w-screen-2xl mx-auto ${className}`}>
    {children}
  </section>
);

export default SectionGrid;
